/* eslint-disable @angular-eslint/prefer-standalone */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  standalone: false,
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'angular-template-alphastar';

  constructor(private router: Router) {}

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });

    document.addEventListener('wheel', this.preventScrollOnNumberInput, {
      passive: false,
    });
    document.addEventListener('keydown', this.preventArrowsOnNumberInput);
  }

  ngOnDestroy() {
    document.removeEventListener('wheel', this.preventScrollOnNumberInput);
    document.removeEventListener('keydown', this.preventArrowsOnNumberInput);
  }

  private preventScrollOnNumberInput = (event: WheelEvent): void => {
    const target = event.target as HTMLInputElement;
    if (
      target &&
      target.tagName &&
      target.tagName.toUpperCase() === 'INPUT' &&
      target.type === 'number'
    ) {
      event.preventDefault();
    }
  };

  private preventArrowsOnNumberInput = (event: KeyboardEvent): void => {
    const target = event.target as HTMLInputElement;
    if (
      target &&
      target.tagName &&
      target.tagName.toUpperCase() === 'INPUT' &&
      target.type === 'number'
    ) {
      if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        event.preventDefault();
      }
    }
  };
}
